import React, { useEffect, useState } from 'react';
import {Button, Pagination, Popconfirm, Modal, Form, Input, Switch, Select, message  , InputNumber} from 'antd';

import Breadcrumbs from '../../../common/breadcrumb/Breadcrumbs';
import Loader from '../../../common/loader/Loader';
import { deleteBonusBankAccount, getAllAvaiableBankList, updateBonusBankAccount } from '../../../api/login/Login';
import { getBonusBankAccount   ,addBonusBankAccount} from '../../../api/login/Login';

const { Option } = Select;



const breadCrumbsTitle = {
    id: '1',
    title_1: 'Bonus Tranaction Master',
    path_1: '/admin/bank-account-list',
    title_2: 'Bank Account List',
  };



const BonusBankAccountList = () => {
      const [loading, setLoading] = useState(false);
        const [data, setData] = useState([]);
        const [pageNo, setPageNo] = useState(1); 
        const [totalData, setTotalData] = useState(0); 
        const [limit , setLimit] = useState(10); 
        const [resetKey, setResetKey] = useState(false); 
        const [allBank , setAllBank] = useState([])
      
        const [isModalVisible, setIsModalVisible] = useState(false);
        const [currentItem, setCurrentItem] = useState(null);
        const [form] = Form.useForm();
        useEffect(()=>{
           const bankList = async()=>{
               try {
                let res = await getAllAvaiableBankList()
                setAllBank(res?.data)
               } catch (error) {
                
               }
           }
           bankList()
        },[])
        
  const handleAdd = () => {
    setCurrentItem(null);
    form.resetFields();
    setIsModalVisible(true);
  };


   const handleOk = async () => {
     try {
       // will resolve only if every rule passes
       const values = await form.validateFields();
       console.log('✅ Valid form data:', values);
         const transformedData = {
       ...values,
       status: values.status ? 'Active' : 'Inactive',
     };

      console.log('✅ Valid form data:', transformedData);
       let res 
       
 
         if (currentItem) {
               // Update
                res  =await updateBonusBankAccount({
  id: currentItem._id,
  data: transformedData,
});
              
             } else {
               // Add new
               res = await addBonusBankAccount(transformedData)
             }
 
             if(res?.error === false)
                 {
                  setIsModalVisible(false);
                  message.success(res?.message);
                  setResetKey(prev => !prev); 
                 }
                 else {
                  message.error(res?.message);
                 }    
   
       // ...continue (API call, close modal, etc.)
     } catch (errorInfo) {
       // errorInfo = { values, errorFields, outOfDate }
       console.log('❌ Validation failed:', errorInfo);
   
       // If you want to scroll to first error:
       // form.scrollToField(errorInfo.errorFields[0].name);
     } finally {
       setLoading(false);
     }
   };
   
 
     const handleDelete = async (id) => {
       setLoading(true);
       // deleteTransactionType()
       try {
        let res  =  await deleteBonusBankAccount(id)
        if(res?.error === false)
         {
          message.success(res?.message);
          setResetKey(prev => !prev); 
         }
         else {
          message.error(res?.message);
         }
      
         
       } catch (error) {
        
       }
       setLoading(false);
     };
 
 
     // ✅ Fetch data function
     const fetchData = async () => {
       let body = {
         page:pageNo,
         limit:limit
       }
       // setLoading(true);
       try {
         const response = await getBonusBankAccount(body)
         console.log(response)
         setData(response.data || []);
         setTotalData(response.data.length || 0); // ✅ update total count
       } catch (error) {
         // message.error('Failed to fetch data');
       }
       // setLoading(false);
     };
   
     // ✅ On mount & when resetKey OR pageNo changes
     useEffect(() => {
       fetchData();
     }, [resetKey, pageNo]);


     const handleEdit = (item) => {
  setCurrentItem(item);
  form.setFieldsValue({
    ...item,
    status: item.status === 'Active', // convert "Active"/"Inactive" to boolean
  });
  setIsModalVisible(true);
};

  const handleBankChange = (value) => {
    console.log(value , "value")
    const selectedBank = allBank.find((bank) => bank.bank_name === value);
    if (selectedBank) {
      form.setFieldsValue({ bank_ifsc: selectedBank.ifsc_code });
    }
  };
  
  return (
    <>
      <Breadcrumbs breadCrumbsTitle={breadCrumbsTitle} />
          {loading && <Loader />}
           <div className="row m-4">
                  <div className="col-xl-12">
                    <div className="card">
                      <div className="card-body p-0">
                        <div className="table-responsive active-projects style-1">
                          <div className="tbl-caption d-flex justify-content-between align-items-center">
                            <h4 className="heading mb-0">Bank Account List</h4>
                            {/* <button type="button" className="btn btn-secondary btn-sm" onClick={handleAdd}>
                              Add Transaction Type
                            </button> */}
                            <Button type="primary" size="small" onClick={handleAdd}>
                            + Add New Bank
                          </Button>
                          </div>
                         <table className="table">
  <thead>
    <tr>
      <th>Bank Name</th>
      <th>Account Number</th>
      <th>IFSC</th>
      <th>Account Holder</th>
      <th>Account Type</th>
      <th>Status</th>
      <th>Action</th>
    </tr>
  </thead>
  <tbody>
    {data?.length > 0 ? (
      data.map((item) => (
        <tr key={item._id}>
          <td>{item.bank_name}</td>
          <td>{item.bank_account_number}</td>
          <td>{item.bank_ifsc}</td>
          <td>{item.bank_account_name}</td>
          <td>{item.account_type}</td>
          <td>
            <span
              className={`badge ${
                item.status === 'Active' ? 'bg-success' : 'bg-danger'
              }`}
            >
              {item.status}
            </span>
          </td>
          <td>
            <div className="d-flex">
              <button
                onClick={() => handleEdit(item)}
                className="btn btn-primary btn-xs sharp me-2"
              >
                <i className="fa fa-pencil" />
              </button>
              <Popconfirm
                title="Delete bank account?"
                onConfirm={() => handleDelete(item._id)}
                okText="Yes"
                cancelText="No"
              >
                <button className="btn btn-danger btn-xs sharp">
                  <i className="fa fa-trash" />
                </button>
              </Popconfirm>
            </div>
          </td>
        </tr>
      ))
    ) : (
      <tr>
        <td colSpan="7" className="text-center">
          No data found.
        </td>
      </tr>
    )}
  </tbody>
</table>

                          <div className="d-flex justify-content-between align-items-center p-2">
                            <div>Total {totalData} entries</div>
                            <Pagination
                              current={pageNo}
                              total={totalData}
                              pageSize={limit}
                              onChange={(page) => setPageNo(page)} // ✅ update pageNo state
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

           <Modal
                  title={currentItem ? 'Update Bank' : 'Add New Bank'}
                  open={isModalVisible}
                  onOk={handleOk}
                  onCancel={() => setIsModalVisible(false)}
                  okText={currentItem ? 'Update' : 'Add'}
                   className="add-bank-modal"
                >
                  <Form form={form} layout="vertical">
     <Form.Item
        name="bank_name"
        label="Bank Name"
        rules={[{ required: true, message: 'Please select a bank' }]}
        validateTrigger={['onBlur', 'onChange']}
      >
        <Select
          showSearch
          placeholder="Search and select a bank"
          optionFilterProp="children"
         
          onChange={handleBankChange}
          filterOption={(input, option) =>
            option.children.toLowerCase().includes(input.toLowerCase())
          }
        >
          {allBank.map((bank) => (
            <Option key={bank._id} value={bank.bank_name}>
              {bank.bank_name}
            </Option>
          ))}
        </Select>
      </Form.Item>

      <Form.Item
        name="bank_ifsc"
        label="IFSC Code"
        rules={[
          { required: true, message: 'IFSC code is required' },
          { pattern: /^[A-Z]{4}0[A-Z0-9]{6}$/, message: 'Enter valid IFSC format' },
        ]}
      >
        <Input placeholder="IFSC code will autofill" />
      </Form.Item>

                  <Form.Item
  name="bank_account_number"
  label="Account Number"
  rules={[
    {
      required: true,
      message: 'Please input your account number',
    },
    {
      pattern: /^\d+$/,
      message: 'Account number must contain digits only',
    },
  ]}
>
  <Input
    inputMode="numeric"          // better mobile keyboard
    maxLength={18}               // optional, e.g., max 18 digits
    onKeyPress={(e) => {
      if (!/[0-9]/.test(e.key)) {
        e.preventDefault();      // blocks non-numeric characters
      }
    }}
    placeholder="Enter account number"
  />
</Form.Item>

 <Form.Item
      name="bank_account_name"
      label="Account Holder Name"
      rules={[{ required: true, message: 'Please enter account holder name' }]}
    >
      <Input placeholder="Enter account holder name" />
    </Form.Item>
 <Form.Item
      name="account_type"
      label="Account Type"
      rules={[{ required: true, message: 'Please select account type' }]}
    >
      <Select placeholder="Select account type">
        <Option value="Savings">Savings</Option>
        <Option value="Current">Current</Option>
      </Select>
    </Form.Item>


                    <Form.Item
            name="status"
            label="Status"
            valuePropName="checked"
            style={{ display: 'flex', alignItems: 'center', marginBottom: 16 }}
          >
            <Switch
              checkedChildren="Active"
              unCheckedChildren="Inactive"
              className="custom-switch"
            />
          </Form.Item>
          
                  </Form>
                </Modal>      
    
    </>
  )
}

export default BonusBankAccountList